import { useMutation } from '@apollo/client';
import React from 'react';
import { GET_BLOCKED_PREVIEWS_QUERY } from '../BlockedPreviewsWell/BlockedPreviewsWell.queries';
import { useNotifier } from '../../../../../common';
import {
    ApproveTemplateContentBuildEmailPreviewsMutation,
    ApproveTemplateContentBuildEmailPreviewsMutationVariables,
} from './__graphqlTypes/ApproveTemplateContentBuildEmailPreviewsMutation';
import { APPROVE_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEWS_MUTATION } from './useApproveBlockedPreview.mutations';

export function useApproveBlockedPreview(): {
    mutationLoading: boolean;
    onApprove: (id: string) => void;
} {
    const notifier = useNotifier();

    const [restartPublishes, { loading }] = useMutation<
        ApproveTemplateContentBuildEmailPreviewsMutation,
        ApproveTemplateContentBuildEmailPreviewsMutationVariables
    >(APPROVE_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEWS_MUTATION, {
        notifyOnNetworkStatusChange: true,
        refetchQueries: [GET_BLOCKED_PREVIEWS_QUERY],
    });

    const onApprove = React.useCallback(
        async (id: string) => {
            if (loading) {
                return;
            }
            const result = await restartPublishes({
                variables: {
                    input: {
                        templateContentBuildEmailPreviewIds: [id],
                    },
                },
            });
            const found = result.data?.approveTemplateContentBuildEmailPreviews.templateContentBuildEmailPreviews.find(
                p => p.id === id,
            );
            if (!found) {
                notifier.error("Failed to approve/send the approved preview. Marked approved but didn't send");
            }
        },
        [loading, notifier, restartPublishes],
    );

    return {
        mutationLoading: loading,
        onApprove,
    };
}
